
export const environment = {
  production: true,
  environmentName: '(prod)',
  // Base_URL: 'https://t4api.ifelsesolutions.in/'
  // Base_URL: 'https://qa-agribid-api.ifelsesolutions.in/'
  // Base_URL: 'https://qa-api.agribid.ai/'
  // Base_URL : 'https://t2api.ifelsesolutions.in/'
  // Base_URL : 'https://api.agribidindia.com/'
  // Base_URL : 'https://localhost:44334/'
  // Base_URL : 'https://api.agribidindia.com/'
  // Base_URL : 'https://api.agribidindia.com/'
  Base_URL : 'https://api.agribid.ai/'
};
